import service from './request'
//登录接口
export function login (data) {
    return service({
        url: `/login`,
        method: 'post',
        data
    })
}
//获取列表接口
export function getList (data) {
    return service({
        url: `/biz/yqInfo/list?pageNum=${data.pageNo}&pageSize=${data.pageSize}&name=${data.title}`,
        method: 'get'
    })
}
//忘记密码接口
export function reSetPwd (data) {
    return service({
        url: `/findPwd/reSetPwd`,
        method: 'post',
        data
    })
}


//新增预警接口
export function addyj (data) {
    return service({
        url: `/biz/yqInfo`,
        method: 'post',
        data
    })
}
//删除
export function deleteyj (id) {
    return service({
        url: '/biz/yqInfo/' + id,
        method: 'delete',

    })
}
export function getyj (id) {
    return service({
        url: '/biz/yqInfo/' + id,
        method: 'get',

    })
}
//修改预警信息
export function modifyyj (data) {
    return service({
        url: `/biz/yqInfo`,
        method: 'put',
        data
    })
}
//发送邮箱验证码
export function sendEmail (data) {
    return service({
        url: `/findPwd/verifyAccount/${data}`,
        method: 'get'
    })
}

//验证code
export function checkCode (data) {
    return service({
        url: `/findPwd/checkCode`,
        method: 'post',
        data
    })
}

//修改预警详情状态
export function changeStatus (data) {
    return service({
        url: `/biz/yqInfo/changeStatus`,
        method: 'put',
        data
    })
}

//联系我们
export function addStatue (data) {
    return service({
        url: `/biz/contactUs`,
        method: 'post',
        data
    })
}

export function changeCode (data) {
    return service({
        url: `/user/updatePwd`,
        method: 'post',
        data
    })
}



export function getUserInfo () {
    return service({
        url: `/getInfo`,
        method: 'get'
    })
}

export function getPlat(data){
    return service({
        url: `biz/userProfile/platforms/${data}`,
        method: 'get'
    })
}


//社媒指数关注列表接口
export function getIndexList(data){
    return service({
        url: `ia/group/list?pageNum=${data.pageNo}&pageSize=${data.pageSize}`,
        method: 'get'
    })
}
//社媒指数获取关键词接口
export function getHotkeyList(data){
    return service({
        url: `ia/hotkey/list?pageNum=${data.pageNo}&pageSize=${data.pageSize}`,
        method: 'get'
    })
}
//社媒指数新增组合
export function addHotkeyList(data){
    return service({
        url: `ia/group`,
        method: 'post',
        data
    })
}

//社媒指数新增组合
export function removeHotKey(data){
    return service({
        url: `ia/group/${data}`,
        method: 'delete'
    })
}
//社媒指数通过id获取详情
export function getDetailByid(data){
    return service({
        url: `ia/group/${data}`,
        method: 'get'
    })
}

//指数关键词关注列表
export function getWordList(data){
    return service({
        url: `ia/follow/list?pageNum=${data.pageNo}&pageSize=${data.pageSize}`,
        method: 'get',
        data
    })
}
export function getWordListIndex(data){
    return service({
        url: `ia/follow/listByHome?pageNum=${data.pageNo}&pageSize=${data.pageSize}`,
        method: 'get'
    })
}
export function removeWordListIndex(data){
    return service({
        url: `ia/follow/${data}`,
        method: 'delete'
    })
}
export function addWordListIndex(data){
    return service({
        url: `ia/follow`,
        method: 'post',
        data
    })
}
export function getAllWordList(data){
    if(data){
        return service({
            url: `ia/keyword/list?keyword=`+data,
            method: 'get'
        })
    }else{
        return service({
            url: `ia/keyword/list`,
            method: 'get'
        })
    }
   
}


export function editAllWordList(data){
    return service({
        url: `ia/group`,
        method: 'put',
        data
    })
}
export function getIndexDetail(data){
    return service({
        url: `ia/index/viewDetailTable`,
        method: 'post',
        data
    })
}
export function getNoticeList(data){
    return service({
        url: `ia/notify/list?pageNum=${data.pageNo}&pageSize=${data.pageSize}&keywords=${data.keywords}`,
        method: 'get',
        data
    })
}
export function getInfoList(data){
    return service({
        url: `ia/info/list`,
        method: 'get',
        data
    })
}
export function deleteNotice(data){
    return service({
        url: `ia/notify/${data}`,
        method: 'delete',
    })
}
export function addNotice(data){
    return service({
        url: `ia/notify`,
        method: 'post',
        data
    })
}
export function getNoticeDetail(data){
    return service({
        url: `ia/notify/${data}`,
        method: 'get'
    })
}
export function editNotice(data){
    return service({
        url: `ia/notify`,
        method: 'put',
        data
    })
}
export function addHotKey(data){
    return service({
        url: `ia/hotkey`,
        method: 'post',
        data
    })
}

export function getHotList(){
    return service({
        url: `top/topInfo/list`,
        method: 'get'
    })
}
export function getHotDetail(id,form){
    return service({
        url:`top/topIndex/list/${id}`,
        method: 'get',
        params:form
    })
}
export function getHotDetail1(id,form){
    return service({
        url:`top/topIndex/frontList/${id}`,
        method: 'get',
        params:form
    })
}
export function getHotNotcieList(data){
    return service({
        url:`top/topNotify/list`,
        method: 'get',
        params:data
    })
}
export function delHotNotcieList(id){
    return service({
        url:`top/topNotify/${id}`,
        method: 'delete'
    })
}
export function addTopNotify(data){
    return service({
        url:`top/topNotify`,
        method: 'post',
        data
    })
}
export function getTopNotify(id){
    return service({
        url:`top/topNotify/${id}`,
        method: 'get',
    })
}
export function editTopNotify(data){
    return service({
        url:`top/topNotify`,
        method: 'put',
        data
    })
}
//获取指数热度前五
export function getTopIndex(){
    return service({
        url:`ia/keyword/listTop`,
        method: 'get'
    })
}